<template>
  <slot />
  <span style="padding: 10px;position: fixed;bottom: 0px;right: 0px;">{{versions.local}}</span>
</template>
<script>
export default {
  name: 'AppLayoutAuth',
  props : [
    'versions'
  ]
}
</script>


